import React, { useState } from "react";
import { DropdownItem, Tooltip } from "reactstrap";

export default function CustomDropdownItem({
  value,
  label,
  secondary,
  callback,
  setSearch,
  tooltip,
}) {
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const toggle = () => {
    setTooltipOpen(!tooltipOpen);
  };

  return (
    <DropdownItem
      onClick={() => {
        setSearch(label || "");
        callback(value);
      }}
      className="custom-dropdown-item"
      id={"Tooltip-" + value}
    >
      <span className={tooltip ? "custom-dropdown-item__label--truncate" : "custom-dropdown-item__label"}>
        {label}
      </span>
      {secondary ? (
        <span
          className={
            tooltip
              ? "custom-dropdown-item__secondary custom-dropdown-item__secondary--truncate"
              : "custom-dropdown-item__secondary"
          }
        >
          {secondary}
        </span>
      ) : null}
      {tooltip && (
        <Tooltip
          isOpen={tooltipOpen}
          target={"Tooltip-" + value}
          toggle={toggle}
        >
          {label}
          {/* El tooltip existe para leer completo lo que la lista trunca: sin la
              segunda línea, la razón social cortada no se podría leer entera. */}
          {secondary ? (
            <span className="custom-dropdown-item__secondary">{secondary}</span>
          ) : null}
        </Tooltip>
      )}
    </DropdownItem>
  );
}
